// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishListNew/index.less
// module id = 1616
// module chunks = 0